<section class="mb-4 stories-map">
  <header class="mb-0 mt-7 overview__header">
    <div class="container overview__header__inner section-inset-b">
      <div class="overview__header__content">
        <span class="fw-bold font-secondary text-secondary">
          {{ 'verhalen-kaart-subtitel' | fromDictionary }}
        </span>
        <h2 class="text-primary">
          {{ 'verhalen-kaart-titel' | fromDictionary }}
          <app-icon anchor="icon-squiggle" class="heading-squiggle"></app-icon>
        </h2>
      </div>
    </div>
  </header>
  <div *ngIf="apiLoaded | async" class="map-container">
    <div class="map-container__loading" *ngIf="!stories()">
      <app-icon class="icon-light animate--rotate icon-xl" anchor="icon-loading"></app-icon>
      <span class="fs-body-md">{{ 'verhalen-laden-op-kaart' | fromDictionary }}</span>
    </div>
    <google-map [options]="options" class="map-card-info-windows" #maps (zoomChanged)="checkMapUpdate()" (centerChanged)="checkMapUpdate()">
      <map-marker-spiderifier
        [options]="spiderOptions"
        [legColors]="legColors"
        [clusterMarkers]="true"
        [clusterOptions]="{
          gridSize: 20,
          maxZoom: 15,
          imagePath: markerClustererImagePath
        }"
      >
        <custom-map-marker
          #marker="customMapMarker"
          (spiderClick)="openInfoWindow(marker, story)"
          *ngFor="let story of stories()"
          [position]="{ lat: +(story.locations?.[0]?.lat || ''), lng: +(story.locations?.[0]?.lng||'') }"
          [icon]="markerIcon(story)"
        ></custom-map-marker>
      </map-marker-spiderifier>
      <map-info-window [options]="infoWindowOptions" #infoWindow="mapInfoWindow">
        <div class="marker-card" *ngIf="selectedStory()">
          <button
            class="button button-icon button--light button--xs marker-card__close"
            (click)="infoWindow.close(); selectedStory.set(null)"
          >
            <app-icon anchor="icon-cross"></app-icon>
          </button>

          <app-story-card [story]="selectedStory()!"></app-story-card>
        </div>
      </map-info-window>
    </google-map>

    <div class="d-flex justify-content-center sticky-map-controls">
      <button class="button button--primary button--md" (click)="recenterMap()" *ngIf="mapMoved">
        <app-icon anchor="icon-map"></app-icon>
        <span>{{ 'kaart-centreren-knoptekst' | fromDictionary }}</span>
      </button>

      <app-map-view-toggle></app-map-view-toggle>
    </div>
  </div>
</section>
